import { gql } from '@src/lib/gql'

export const REQUEST_ADVISOR_PAYOUT = gql`
  mutation RequestAdvisorPayout($input: RequestAdvisorPayoutInput!) {
    requestAdvisorPayout(input: $input) {
      advisorPayout {
        id
        advisorPayoutId
        amountUsd
        statusKey
        status {
          id
          key
          title
        }
        failureReason
        requestedAt
        completedAt
        failedAt
        createdAt
        approvedAt
        rejectedAt
        rejectionReason
        canceledAt
        canceledByUserId
        canCurrentUserCancel
      }
    }
  }
`
